<div class="component-faq-view">
  <app-faq-standalone></app-faq-standalone>
</div>
